import Footer from "../auth/layout/Footer";
import { useTranslation } from "react-i18next";

const TravelFooter = () => {
  const { t } = useTranslation("pages", { keyPrefix: "travel.footer" });
  return <Footer footer={t} />;
};

export default TravelFooter;
